"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var en_US_1 = __importDefault(require("../../locale/en_US"));
var AttributeCombo_1 = __importDefault(require("../Filter/AttributeCombo/AttributeCombo"));
require("./RuleGenerator.css");
var RuleGeneratorUtil_1 = __importDefault(require("../../Util/RuleGeneratorUtil"));
var KindField_1 = require("../Symbolizer/Field/KindField/KindField");
var WellKnownNameField_1 = require("../Symbolizer/Field/WellKnownNameField/WellKnownNameField");
var LocaleWrapper_1 = require("../LocaleWrapper/LocaleWrapper");
var chroma_js_1 = require("chroma-js");
var ColorRampCombo_1 = require("./ColorRampCombo/ColorRampCombo");
var ColorSpaceCombo_1 = require("./ColorSpaceCombo/ColorSpaceCombo");
var ColorsPreview_1 = __importDefault(require("./ColorsPreview/ColorsPreview"));
var ClassificationCombo_1 = require("./ClassificationCombo/ClassificationCombo");
var _get = require('lodash/get');
var RuleGenerator = /** @class */ (function (_super) {
    __extends(RuleGenerator, _super);
    function RuleGenerator(props) {
        var _this = _super.call(this, props) || this;
        _this.onAttributeChange = function (attributeName) {
            var internalDataDef = _this.props.internalDataDef;
            var attributeType = _get(internalDataDef, "schema.properties[" + attributeName + "].type");
            var classificationMethod = _this.state.classificationMethod;
            if (attributeType === 'string' && classificationMethod === 'kmeans') {
                classificationMethod = undefined;
            }
            _this.setState({
                attributeName: attributeName,
                attributeType: attributeType,
                levelOfMeasurement: attributeType === 'string' ? 'nominal' : 'cardinal',
                classificationMethod: classificationMethod
            });
        };
        _this.onLevelOfMeasurementChange = function (event) {
            var levelOfMeasurement = event.target.value;
            _this.setState({ levelOfMeasurement: levelOfMeasurement });
        };
        _this.onClassificationChange = function (classificationMethod) {
            _this.setState({ classificationMethod: classificationMethod });
        };
        _this.onNumberChange = function (numberOfRules) {
            _this.setState({
                numberOfRules: numberOfRules
            });
        };
        _this.onColorRampChange = function (colorRamp) {
            _this.setState({ colorRamp: colorRamp });
        };
        _this.onColorSpaceChange = function (colorSpace) {
            _this.setState({ colorSpace: colorSpace });
        };
        _this.onSymbolizerKindChange = function (symbolizerKind) {
            var wellKnownName = _this.state.wellKnownName;
            if (symbolizerKind === 'Mark' && !wellKnownName) {
                wellKnownName = 'Circle';
            }
            else {
                wellKnownName = undefined;
            }
            _this.setState({
                symbolizerKind: symbolizerKind,
                wellKnownName: wellKnownName
            });
        };
        _this.onWellKnownNameFieldChange = function (wellKnownName) {
            _this.setState({
                wellKnownName: wellKnownName
            });
        };
        _this.onGenerateClick = function () {
            var _a = _this.props, onRulesChange = _a.onRulesChange, internalDataDef = _a.internalDataDef, colorRamps = _a.colorRamps;
            var _b = _this.state, attributeName = _b.attributeName, classificationMethod = _b.classificationMethod, colorRamp = _b.colorRamp, levelOfMeasurement = _b.levelOfMeasurement, numberOfRules = _b.numberOfRules, symbolizerKind = _b.symbolizerKind, wellKnownName = _b.wellKnownName;
            var rules = RuleGeneratorUtil_1.default.generateRules({
                attributeName: attributeName,
                classificationMethod: classificationMethod,
                colors: colorRamps[colorRamp],
                data: internalDataDef,
                levelOfMeasurement: levelOfMeasurement,
                numberOfRules: numberOfRules,
                symbolizerKind: symbolizerKind,
                wellKnownName: wellKnownName
            });
            if (classificationMethod === 'kmeans') {
                _this.setState({
                    numberOfRules: rules.length
                });
            }
            if (onRulesChange) {
                onRulesChange(rules);
            }
        };
        var internalDataDef = _this.props.internalDataDef;
        var symbolizerKind = RuleGeneratorUtil_1.default.guessSymbolizerFromData(internalDataDef);
        _this.minNrClasses = 2;
        _this.state = {
            symbolizerKind: symbolizerKind,
            wellKnownName: 'Circle',
            colorRamp: props.colorRamps && props.colorRamps.GeoStyler ? 'GeoStyler' : undefined,
            colorSpace: 'hsl',
            numberOfRules: 2,
            hasError: false
        };
        return _this;
    }
    RuleGenerator.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    RuleGenerator.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement("h1", null, "An error occured in the RuleGenerator UI.");
        }
        var _a = this.props, colorRamps = _a.colorRamps, colorSpaces = _a.colorSpaces, internalDataDef = _a.internalDataDef, locale = _a.locale;
        var _b = this.state, attributeName = _b.attributeName, attributeType = _b.attributeType, classificationMethod = _b.classificationMethod, colorRamp = _b.colorRamp, colorSpace = _b.colorSpace, levelOfMeasurement = _b.levelOfMeasurement, numberOfRules = _b.numberOfRules, symbolizerKind = _b.symbolizerKind, wellKnownName = _b.wellKnownName;
        var previewColors = RuleGeneratorUtil_1.default.generateColors(colorRamps[colorRamp], numberOfRules, colorSpace);
        return (React.createElement("div", { className: "gs-rule-generator" },
            React.createElement(antd_1.Form, { layout: "horizontal" },
                React.createElement(AttributeCombo_1.default, { value: attributeName, internalDataDef: internalDataDef, onAttributeChange: this.onAttributeChange, validateStatus: attributeName ? 'success' : 'warning' }),
                React.createElement(antd_1.Form.Item, { label: locale.levelOfMeasurement },
                    React.createElement(antd_1.Radio.Group, { onChange: this.onLevelOfMeasurementChange, value: levelOfMeasurement, buttonStyle: "solid" },
                        React.createElement(antd_1.Radio.Button, { value: "nominal" }, locale.nominal),
                        React.createElement(antd_1.Radio.Button, { value: "cardinal", disabled: attributeType === 'string' }, locale.cardinal))),
                levelOfMeasurement !== 'cardinal' ? null :
                    React.createElement(antd_1.Form.Item, { label: locale.classification },
                        React.createElement(ClassificationCombo_1.ClassificationCombo, { classification: classificationMethod, onChange: this.onClassificationChange })),
                React.createElement(antd_1.Form.Item, { label: locale.numberOfRules, validateStatus: classificationMethod === 'kmeans'
                        ? 'warning'
                        : numberOfRules < this.minNrClasses
                            ? 'error'
                            : undefined, help: classificationMethod === 'kmeans'
                        ? locale.numberOfRulesViaKmeans
                        : numberOfRules < this.minNrClasses
                            ? locale.colorRampMinClassesWarningPre + " " + this.minNrClasses + " " + locale.colorRampMinClassesWarningPost
                            : undefined },
                    React.createElement(antd_1.InputNumber, { min: this.minNrClasses, max: 100, value: numberOfRules, onChange: this.onNumberChange })),
                React.createElement("fieldset", null,
                    React.createElement("legend", null, locale.symbolizer),
                    React.createElement(antd_1.Form.Item, null,
                        React.createElement(KindField_1.KindField, { kind: symbolizerKind, symbolizerKinds: [
                                'Fill',
                                'Mark',
                                'Line'
                            ], onChange: this.onSymbolizerKindChange })),
                    symbolizerKind !== 'Mark' ? null :
                        React.createElement(antd_1.Form.Item, null,
                            React.createElement(WellKnownNameField_1.WellKnownNameField, { wellKnownName: wellKnownName, onChange: this.onWellKnownNameFieldChange })),
                    React.createElement(antd_1.Form.Item, { label: locale.colorRamp, help: numberOfRules < this.minNrClasses ?
                            locale.colorRampMinClassesWarningPre + " " + this.minNrClasses + " " + locale.colorRampMinClassesWarningPost
                            : undefined },
                        React.createElement(ColorRampCombo_1.ColorRampCombo, { colorRamps: colorRamps, colorRamp: colorRamp, onChange: this.onColorRampChange })),
                    colorSpaces.length > 0 ?
                        React.createElement(antd_1.Form.Item, { label: locale.colorSpace },
                            React.createElement(ColorSpaceCombo_1.ColorSpaceCombo, { colorSpace: colorSpace, colorSpaces: colorSpaces, onChange: this.onColorSpaceChange }))
                        : null,
                    React.createElement(antd_1.Form.Item, { label: locale.preview },
                        React.createElement(ColorsPreview_1.default, { colors: previewColors }))),
                React.createElement(antd_1.Form.Item, null,
                    React.createElement(antd_1.Button, { className: "gs-rule-generator-submit-button", type: "primary", onClick: this.onGenerateClick, disabled: numberOfRules < this.minNrClasses || !attributeName }, locale.generateButtonText)))));
    };
    RuleGenerator.defaultProps = {
        locale: en_US_1.default.GsRuleGenerator,
        colorSpaces: ['hsl', 'hsv', 'hsi', 'lab', 'lch', 'hcl', 'rgb'],
        colorRamps: __assign({ GeoStyler: ['#E7000E', '#F48E00', '#FFED00', '#00943D', '#272C82', '#611E82'], GreenRed: ['#00FF00', '#FF0000'] }, chroma_js_1.brewer)
    };
    RuleGenerator.componentName = 'RuleGenerator';
    return RuleGenerator;
}(React.Component));
exports.RuleGenerator = RuleGenerator;
exports.default = LocaleWrapper_1.localize(RuleGenerator, RuleGenerator.componentName);
//# sourceMappingURL=RuleGenerator.js.map